<template>
  <DBox
    :id="'settings-accounting-tax_types_list'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add')} ${$t('tax_type')}`"
    @add_click="onAddTaxTypeClick"
  >
    <div class="cmp-settings-accounting-tax_types_list">
      <NTable
        :id="'settings-accounting-tax_types_list'"
        class="h2 dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('format')">
              <span>{{ item.format_name }}</span>
            </td>
            <td v-bind="tdcon('vat_category')">
              <Dropdown2
                 class="dbox1"
                :showLabel="false"
                :disabled="false"
                :options="vatCategoryTV||[]"
                :selected="
                  vatCategoryTV.find(
                    v => v.value == item.vat_category_id
                  )
                "
                v-on:selectedChange="
                  e => onVatChange('vat_category_id', e, item)
                "
                :bb="'0px'"
              ></Dropdown2>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { createTV } from '../../../../models/text-value.model';

export default {
  components: {
    NTable,
    DBox
  },
  props: {
    accountingSettingsData: {
      type: Object,
      default: () => []
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true,
        footer: false
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("format", {}),
        createTableHeader("vat_category", {}),
      ];
    },
    list: function() {
      return this.accountingSettingsData?.formats || [];
    },
    vatCategoryTV:function(){
      return createTV(this.accountingSettingsData?.vat_categories,'vat_category_name','vat_category_id');
    }
  },
  methods: {
    onAddTaxTypeClick: function() {
      this.$emit("add_click", true);
    },

    onVatChange:function(name, e, item){
      
       this.$emit("change", { name:name ,text:e.text,value:e.value ,item:item });
      console.log(name, e, item);


    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-accounting-tax_types_list {
  height: 100%;
  .dt-ntable {
    td {
      &.tax_deduction_text {
        .checkbox-container {
          width: min-content;
        }
      }
    }
  }
}
</style>
